const style = {
    body: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    my404: {
        marginTop: 15,
        fontSize: 350,
        fontFamily: 'Questrial',
        color: 'black',
    },
    myPageNotFound: {
        marginTop: -450,
        fontSize: 50,
        fontFamily: 'Questrial',
        color: 'black',
    },
    myBackHome: {
        marginTop: -55,
        fontSize: 35,
        borderRadius: 10,
        fontFamily: 'Questrial',
        padding: 10,
        color: 'black',
    },
    img:{
        marginTop: 120,
        height: 300,
        width: 300,
},
    my404G: {
      display: 'flex',
    },
};

export default style;